import type { TeamMember } from '../types/team-types';
import { MemberRole } from '@/services/internal-api/accounts/types/accounts-api-service-enums';

import { TEAM_MEMBER_STATUS } from '../types/team-enums';

export function getAvailableRoles(currentUserRole: TeamMember['role'] | null): MemberRole[] {
  const allRoles = Object.values(MemberRole);
  if (currentUserRole === MemberRole.ADMIN) {
    return allRoles.filter(role => role !== MemberRole.OWNER);
  }
  return allRoles;
}

export function capitalizeRole(role: string): string {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

const ADMIN_ROLES: readonly string[] = ['admin', 'owner'];

export function isAdminOrOwner(role: string | null): boolean {
  return role !== null && ADMIN_ROLES.includes(role);
}

export function filterTeamMembers(
  members: TeamMember[],
  searchTerm: string,
  activeTab: string
): TeamMember[] {
  const lowerSearch = searchTerm.toLowerCase();
  return members.filter(member => {
    const matchesSearch =
      member.name.toLowerCase().includes(lowerSearch) ||
      member.email.toLowerCase().includes(lowerSearch);
    const matchesTab = activeTab === 'pending' ? member.status === TEAM_MEMBER_STATUS.PENDING : true;
    return matchesSearch && matchesTab;
  });
}

export function getMemberCounts(members: TeamMember[]): {
  all: number;
  pending: number;
} {
  return {
    all: members.length,
    pending: members.filter(m => m.status === TEAM_MEMBER_STATUS.PENDING).length,
  };
}
